module.exports = __webpack_public_path__ + "img/voileMagazine-modal.4f4cc4c7.jpg";